import React, { useEffect, useState } from "react";
import { getLiveClasses } from "../../lib/LiveClass";
import { useNavigate, useOutletContext } from "react-router-dom";
import { getContentsByTopicID } from "../../lib/LiveclassContent";
import { markAttendance } from "../../lib/LiveclassContent";
import { useAuth } from "../../context/AuthProvider";

export default function LiveClasses() {


  const [selectedSession, setSelectedSession] = useState(null);
  const [topicContents, setTopicContents] = useState([]);
  const [contentLoading, setContentLoading] = useState(false);

  const { selectedDate } = useOutletContext();
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [openDropdown, setOpenDropdown] = useState({});
  const navigate = useNavigate();

  //const user = JSON.parse(localStorage.getItem("user") || "{}");

  const { user } = useAuth();



  const role =
    user?.role?.toLowerCase();

  const isStudent = role === "student";

  const isTeacher = role === "teacher";

  const isAdmin = role === "admin";


  // ================= FILTER =================
  const selectedDateString = new Date(selectedDate).toDateString();

  const filteredSessions = sessions.filter(
    (session) =>
      new Date(session.startdatetime).toDateString() === selectedDateString
  );

  // ================= NEXT CLASS =================
  const now = new Date();

  const nextClass = sessions
    .filter((session) => new Date(session.startdatetime) > now)
    .sort(
      (a, b) =>
        new Date(a.startdatetime) - new Date(b.startdatetime)
    )[0];

  // ================= TODAY SESSIONS =================

  const todaySessions = sessions.filter(
    (session) =>
      new Date(session.startdatetime).toDateString() ===
      new Date().toDateString()
  );

  // Teacher
  // ================= UPCOMING SESSIONS =================

  const upcomingSessions = sessions.filter(
    (session) =>
      new Date(session.startdatetime) > new Date()
  );

  // ================= FETCH =================
  useEffect(() => {
    fetchLiveClass();
  }, []);

  const fetchLiveClass = async () => {
    try {
      setLoading(true);

      const userId =
        user?.uuid || user?.id || localStorage.getItem("userId");

      const response = await getLiveClasses(userId);
      const res = response?.data || response;

      if (!Array.isArray(res) || res.length === 0) {
        setSessions([]);
        return;
      }

      const formatted = res.map((item) => ({
        id: item.id,

        startdatetime: item.startdatetime,
        enddatetime: item.enddatetime,
        liveclasslink: item.liveclasslink || item.liveClassLink,
        subject: item.subjectName,
        chapter: item.chapter,
        topicId: item.topicId,
        topic: item.topic,
        teacher: item.teacherName,
        class:item.classname,
        rating: item.rating,
        recordedVideoUrl: item.recordedVideoUrl,
        notesUrl: item.notesUrl,
        testUrl: item.testUrl,
        batchName: item.batchName,
       
        role: item.role,
      }));
      setSessions(formatted);
    } catch (error) {
      console.error("Live Class API Error:", error);
      setError("Failed to load live classes");
    } finally {
      setLoading(false);
    }
  };

  //===================handleViewDetails======================

  const handleViewDetails = async (session) => {

    try {

      setSelectedSession(session);

      setContentLoading(true);

      const res = await getContentsByTopicID(session.topicId);

      console.log("FULL RESPONSE:", res);

      setTopicContents(res || []);

    } catch (err) {

      console.error(err);

    } finally {

      setContentLoading(false);

    }

  };

  //=====================handlejoinsession==============
  const handleJoinSession = async (session) => {

    try {

      const user =
        JSON.parse(localStorage.getItem("user"));

      const payload = {

        userId: user?.uuid,

        liveClassId: session.id,

        topicId: session.topicId,

        deviceType: "Web",

        ipAddress: ""
      };

      // Save Attendance
      await markAttendance(payload);

      // Open Live Class
      if (session.liveclasslink) {

        window.open(
          session.liveclasslink,
          "_blank"
        );
      }

    } catch (err) {

      console.error(
        "Attendance Error:",
        err
      );
    }
  };

  //====================GroupContent=======================

  const groupedContents = topicContents.reduce((acc, item) => {

    const type = item.mediatype?.toLowerCase();

    if (!acc[type]) {
      acc[type] = [];
    }

    acc[type].push(item);

    return acc;

  }, {});


  // ================= SESSION STATUS =================

  const getSessionStatus = (session) => {

    const now = new Date();

    const start = new Date(session.startdatetime);

    const end = new Date(session.enddatetime);

    if (now < start) {
      return "Upcoming";
    }

    if (now > end) {
      return "Completed";
    }

    return "Live";
  };

  return (
    <div className="min-h-screen bg-secondary p-4 md:p-6">

      {/* ================= STATES ================= */}
      {loading && (
        <div className="text-center py-10 text-gray-500">
          Loading sessions...
        </div>
      )}

      {error && (
        <div className="text-center text-red-500 py-4">{error}</div>
      )}

      {!loading && sessions.length === 0 && (
        <div className="text-center text-black py-10">
          No sessions available
        </div>
      )}

      {/* ================= MAIN ================= */}
      {/* ================= MAIN ================= */}

      {/* ===================================================== */
/* STUDENT UI */
/* ===================================================== */}

      {isStudent &&
        !loading &&
        sessions.length > 0 &&
        !selectedSession && (

          filteredSessions.length === 0 ? (

            <div className="text-center py-10">

              <p className="text-red-500 font-medium">
                There are no classes scheduled today
              </p>

              {nextClass && (
                <p className="text-sm text-gray-500 mt-2">
                  Your next class:
                  {" "}
                  {new Date(
                    nextClass.startdatetime
                  ).toLocaleString()}
                </p>
              )}

            </div>

          ) : (

            <div>

              {/* SESSION HEADER */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                {/* <div className="hidden md:block font-semibold text-gray-600">
                Sessions
              </div> */}

                {filteredSessions.map((s, i) => (
                  <div
                    key={i}
                    className="bg-gray-300 mb-2 px-4 py-2 rounded-md flex justify-between items-center text-sm font-medium"
                  >
                    <span>
                      Session {i + 1} |{" "}
                      {new Date(s.startdatetime).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </span>
                    <span>▼</span>
                  </div>
                ))}
              </div>

              {/* TABLE */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">

                {/* LEFT LABELS */}
                {/* <div className="hidden md:flex flex-col text-sm text-gray-600 space-y-4 pt-2">
                <p>Time Slot (IST):</p>
                <p>Subject:</p>
                <p>Chapter:</p>
                <p>Topic:</p>
                <p>Teacher:</p>
              </div> */}

                {/* SESSION DATA */}
                {filteredSessions.map((s) => {
                  const start = new Date(s.startdatetime);
                  const end = new Date(s.enddatetime);
                  const now = Date.now();

                  const isLive =
                    now >= start.getTime() &&
                    now <= end.getTime();

                  return (
                    <div
                      key={s.id}
                      className="bg-white rounded-md p-4 shadow-sm flex flex-col justify-between"
                    >
                      <div className="space-y-4 text-sm text-gray-700">
                        <p>
                          <span className="text-black-900 font-bold">Time:</span>
                          {start.toLocaleTimeString()} -{" "}
                          {end.toLocaleTimeString()}
                        </p>
                        <p><span className="text-black-900 font-bold">Subject:</span>  {s.subject || "-"}</p>
                        <p><span className="text-black-900 font-bold">Chapter:</span> {s.chapter || "-"}</p>
                        <p><span className="text-black-900 font-bold">Topic:</span> {s.topic || "-"}</p>
                        <p>
                          <span className="text-black-900 font-bold">Teacher:</span>
                          {s.teacher || "-"}{" "}
                          {/* {s.rating && (
                          // <span className="ml-2 text-yellow-500">
                          //   ⭐ {s.rating}
                          // </span>
                        )} */}
                        </p>
                      </div>

                      <div className="mt-4">
                        <button
                          // onClick={() =>
                          //   s.liveclasslink &&
                          //   window.open(s.liveclasslink, "_blank")
                          // }
                          // disabled={!isLive}
                          // className={`w-full py-2 rounded-md text-sm font-medium ${
                          //   isLive
                          //     ? "bg-red-600 text-white"
                          //     : "bg-gray-300 text-gray-500 cursor-not-allowed"
                          // }`}
                          onClick={() => handleJoinSession(s)}
                          disabled={!isLive}
                          className={`w-full py-2 rounded-md text-sm font-medium ${isLive
                              ? "bg-red-600 text-white"
                              : "bg-gray-300 text-gray-500 cursor-not-allowed"
                            }`}
                        >
                          {isLive ? "Join Session" : "Not Live Yet"}


                        </button>

                        <p className="text-xs text-red-500 text-center mt-2">
                          Attendance marked on joining
                        </p>
                      </div>

                      <button
                        onClick={() => handleViewDetails(s)}
                        className="bg-primary text-white px-3 py-1 rounded"
                      >
                        View Details
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          )
        )}

      {/* ===================================================== */
        /* TEACHER UI */
       /* ===================================================== */}

      {isTeacher &&
        !loading &&
        !selectedSession && (

          <div className="space-y-8">

            {/* TODAY SESSIONS */}

             <div>

              {/* SESSION HEADER */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                {/* <div className="hidden md:block font-semibold text-gray-600">
                Sessions
              </div> */}

                {filteredSessions.map((s, i) => (
                  <div
                    key={i}
                    className="bg-gray-300 mb-2 px-4 py-2 rounded-md flex justify-between items-center text-sm font-medium"
                  >
                    <span>
                      Session {i + 1} |{" "}
                      {new Date(s.startdatetime).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </span>
                    <span>▼</span>
                  </div>
                ))}
              </div>

              {/* TABLE */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">

                {/* LEFT LABELS */}
                {/* <div className="hidden md:flex flex-col text-sm text-gray-600 space-y-4 pt-2">
                <p>Time Slot (IST):</p>
                <p>Subject:</p>
                <p>Chapter:</p>
                <p>Topic:</p>
                <p>Teacher:</p>
              </div> */}

                {/* SESSION DATA */}
                {filteredSessions.map((s) => {
                  const start = new Date(s.startdatetime);
                  const end = new Date(s.enddatetime);
                  const now = Date.now();

                  const isLive =
                    now >= start.getTime() &&
                    now <= end.getTime();

                  return (
                    <div
                      key={s.id}
                      className="bg-white rounded-md p-4 shadow-sm flex flex-col justify-between"
                    >
                      <div className="space-y-4 text-sm text-gray-700">
                        <p>
                          <span className="text-black-900 font-bold">Time:</span>
                          {start.toLocaleTimeString()} -{" "}
                          {end.toLocaleTimeString()}
                        </p>
                        <p><span className="text-black-900 font-bold">Subject:</span>  {s.subject || "-"}</p>
                        <p><span className="text-black-900 font-bold">Chapter:</span> {s.chapter || "-"}</p>
                        <p><span className="text-black-900 font-bold">Topic:</span> {s.topic || "-"}</p>
                        <p>
                          <span className="text-black-900 font-bold">Class:</span>
                          {s.class || "-"}{" "}
                          {/* {s.rating && (
                          // <span className="ml-2 text-yellow-500">
                          //   ⭐ {s.rating}
                          // </span>
                        )} */}
                        </p>
                      </div>

                      <div className="mt-4">
                        <button
                          // onClick={() =>
                          //   s.liveclasslink &&
                          //   window.open(s.liveclasslink, "_blank")
                          // }
                          // disabled={!isLive}
                          // className={`w-full py-2 rounded-md text-sm font-medium ${
                          //   isLive
                          //     ? "bg-red-600 text-white"
                          //     : "bg-gray-300 text-gray-500 cursor-not-allowed"
                          // }`}
                          onClick={() => handleJoinSession(s)}
                          disabled={!isLive}
                          className={`w-full py-2 rounded-md text-sm font-medium ${isLive
                              ? "bg-red-600 text-white"
                              : "bg-gray-300 text-gray-500 cursor-not-allowed"
                            }`}
                        >
                          {isLive ? "Conduct Session" : "Not Live Yet"}


                        </button>

                        {/* <p className="text-xs text-red-500 text-center mt-2">
                          Attendance marked on joining
                        </p> */}
                      </div>

                      {/* <button
                        onClick={() => handleViewDetails(s)}
                        className="bg-primary text-white px-3 py-1 rounded"
                      >
                        View Details
                      </button> */}
                    </div>
                  );
                })}
              </div>
            </div>

          </div>
        )}
    </div>
  );
}



























